import './SequenceList.css';

const SEQUENCE_LIST_TITLE_ID = 'sequence_list_header_title';
const APPLICATION_STATUS_CONTAINER_ID = 'application_status_container';
const PLAYING_APPLICATION_NAME_ID = 'playing_application_name';
const PLAYING_APPLICATION_STATUS_ID = 'playing_application_status';
const SEQUENCE_LIST_ID = 'sequence_list_content';

/**
 * The jQuery query selector for the SequenceList header title.
 * Useful when trying to get the element via jQuery.
 */
export const SEQUENCE_LIST_TITLE_QUERY_SELECTOR = '#' + SEQUENCE_LIST_TITLE_ID;

/**
 * The jQuery query selector for the SequenceList application status container.
 * Useful when trying to get the element via jQuery.
 */
export const APPLICATION_STATUS_CONTAINER_QUERY_SELECTOR = '#' + APPLICATION_STATUS_CONTAINER_ID;

/**
 * The jQuery query selector for the SequenceList selected application name.
 * Useful when trying to get the element via jQuery.
 */
export const PLAYING_APPLICATION_NAME_QUERY_SELECTOR = '#' + PLAYING_APPLICATION_NAME_ID;

/**
 * The jQuery query selector for the SequenceList selected application name.
 * Useful when trying to get the element via jQuery.
 */
export const PLAYING_APPLICATION_STATUS_QUERY_SELECTOR = '#' + PLAYING_APPLICATION_STATUS_ID;

/**
 * The jQuery query selector for the SequenceList.
 * Useful when trying to get the element via jQuery.
 */
export const SEQUENCE_LIST_QUERY_SELECTOR = '#' + SEQUENCE_LIST_ID;

/**
 * Creates the empty sequence list container.
 */
export const SequenceList = (): JQuery => {
  const container = $('<div>')
    .attr('id', 'sequence_list');

  const header = $('<div>')
    .attr('id', 'sequence_list_header');

  const headerTitle = $('<div>')
    .attr('id', SEQUENCE_LIST_TITLE_ID)
    .addClass('title')
    .text('Sequence Status');

  const applicationStatus = ApplicationStatus();

  const sequenceList = $('<div>')
    .attr('id', SEQUENCE_LIST_ID)
    .addClass('scrollbar');

  return container.append(
    header.append(
      headerTitle,
      applicationStatus,
    ),
    sequenceList,
  );
};

const ApplicationStatus = (): JQuery => {
  const container = $('<div>')
    .attr('id', APPLICATION_STATUS_CONTAINER_ID)
    .addClass('title');

  const applicationName = $('<div>')
    .attr('id', PLAYING_APPLICATION_NAME_ID)
    .addClass('title');

  const applicationStatus = $('<div>')
    .attr('id', PLAYING_APPLICATION_STATUS_ID)
    .addClass('title');

  return container.append(
    applicationName,
    applicationStatus,
  );
};
